import { render, staticRenderFns } from "./EasyPay.vue?vue&type=template&id=5d3ebc16"
import script from "./EasyPay.vue?vue&type=script&lang=js"
export * from "./EasyPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports